import { toSelection } from './selection';

const HEALED = 'healed';

// "Healed" never matches fixed (archived) anomalies, so turning Show Fixed on
// drops it from the selected review statuses instead of showing an always-empty list.
export const filtersOnArchivedToggle = (filters, archived) => {
  const selected = toSelection(filters.review_status);
  if (!archived || !selected.includes(HEALED)) return filters;
  return { ...filters, review_status: selected.filter((s) => s !== HEALED) };
};

/** Review Status multi-select options; Healed is disabled while Show Fixed is on. */
export const reviewStatusOptions = (showArchived) => [
  { value: 'unreviewed', label: 'Unreviewed' },
  { value: 'reviewed', label: 'Reviewed' },
  { value: 'true_anomaly', label: 'True Anomaly' },
  { value: 'false_positive', label: 'False Positive' },
  { value: HEALED, label: 'Healed', disabled: !!showArchived },
];

// List order, sorted on the server (DPS-4718). The default is unchanged.
export const DEFAULT_ANOMALY_SORT = 'last_seen_desc';
export const ANOMALY_SORT_OPTIONS = [
  { value: 'last_seen_desc', label: 'Last seen (newest first)' },
  { value: 'first_seen_asc', label: 'First seen (oldest first)' },
];

/**
 * The anomaly row after its sample classifications were saved. Verified By is
 * whatever the server stored (first verifier, replaced only on a real change).
 */
export function rowAfterClassificationSave(row, serialized, res) {
  const next = { ...row, sample_classifications: serialized };
  if (!res) return next;
  // The server's rolled-up status wins, including null (every verdict cleared).
  const reviewStatus = ('review_status' in res ? res.review_status : row.review_status) ?? null;
  next.review_status = reviewStatus;
  if (res.classified_by) {
    next.classified_by = res.classified_by;
    next.classified_at = res.classified_at;
  }
  if ('verified_by' in res) {
    next.verified_by = res.verified_by ?? null;
    next.verified_at = res.verified_at ?? null;
  }
  return next;
}
